import { FullscreenTypeEnums } from "Data/settings";
import { encode } from "Helpers/enc";
import { isNil, omitBy, map, filter, indexOf } from "lodash";

const response = (data: any) => {
  // the url starts from the base url and then appended with the encoded id
  // sample url: app.diolko.com/public/rack/...
  const hostName = window.location.host;
  const baseUrl =
    hostName +
    "/public/" +
    FullscreenTypeEnums?.[data.type]?.toLowerCase() +
    "/";

  const urlID = data.sortingLinkID;

  let name: string | null = null;

  if (data.type === FullscreenTypeEnums.RACK) {
    if (data.rackData) name = data.rackData?.name;

    if (!name) name = FullscreenTypeEnums.RACK;
  }

  if (data.type === FullscreenTypeEnums.TROLLEY) {
    if (data.servicePointData) {
      name = data.servicePointData?.locationName;
    }

    if (!name) name = FullscreenTypeEnums.TROLLEY;
  }

  const result = {
    companyOrgID: data.companyOrgID,
    createdAt: data.createdAt,
    daysToExpire: data.daysToExpire,
    expiresAt: data.expiresAt,
    whitelist: data.ipAddresses,
    mapType: FullscreenTypeEnums?.[data.type],
    name: name,
    rackID: data.rackID,
    type: data.type,
    url: data._id ? baseUrl + urlID : null,
    // for shortUrl, show the first 5 uuid number, but this is for preview only
    shortUrl: urlID,
    // if "", this means all locations are selected
    servicePointID: data.servicePointID ?? "",
    _id: data._id,
  };

  return omitBy(result, isNil);
};

export default response;
